<template>
  <div class="col-12 row">
    <div class="col-6 colMD12">
      <h3>ویرایش رمز عبور</h3>
      <b-form-group label="رمبز قبلی :" class="col-12">
        <b-form-input v-model="oldPassword"></b-form-input>
      </b-form-group>
      <b-form-group label="رمز جدید :" class="col-12">
        <b-form-input v-model="password"></b-form-input>
      </b-form-group>
      <b-form-group label="تکرار رمز جدید :" class="col-12">
        <b-form-input v-model="rePassword"></b-form-input>
      </b-form-group>
      <b-button
        @click="editPassword()"
        class="profileButton"
        :class="{ disbledLink: disabled12 == true }"
        type="submit"
        >ویرایش</b-button
      >
    </div>
    <div class="col-6 colMD12">
      <h3>ویرایش اطلاعات پایه</h3>
      <b-form-group label="نام :" class="col-12">
        <b-form-input v-model="name"></b-form-input>
      </b-form-group>
      <b-form-group label="ایمیل :" class="col-12">
        <b-form-input v-model="email"></b-form-input>
      </b-form-group>
      <b-button
        @click="editInfo()"
        class="profileButton"
        :class="{ disbledLink: disabled1 == true }"
        type="submit"
      
        >ویرایش</b-button
      >
    </div>
  </div>
</template>
<script>
import { BButton, BFormInput, BFormGroup } from "bootstrap-vue";
export default {
  methods: {
    editPassword() {  let form = new FormData();
      form.append("_method", "PUT");
      form.append("old_password", this.oldPassword);
      form.append("password", this.password);
      form.append("password_confirmation", this.rePassword);
      this.disabled2 = true;
      this.$axios
        .post("/user/profile", form)
        .then((res) => {
          this.$swal({
            title: "عملیات موفقیت آمیز بود",
            text: "رمز عبور شما با موفقیت بروز رسانی شد",
            icon: "success",
            showConfirmButton: true,
            confirmButtonText: "تایید"
          });
          this.disabled2 = false;
        })
        .catch((err) => {
          this.disabled2 = false;
          this.$swal({
            title: "عملیات موفقیت آمیز نبود",
            text: "اطلاعات رمز عبور را به صورت کامل وارد نمایید",
            icon: "warning",
            showConfirmButton: true,
            confirmButtonText: "تایید"
          });
        });
    },
    editInfo() {
      let form = new FormData();
      form.append("_method", "PATCH");
      form.append("name", this.name);
      form.append("email", this.email);
      this.disabled1 = true;
      this.$axios
        .post("/user/profile", form)
        .then((res) => {
          this.$swal({
            title: "عملیات موفقیت آمیز بود",
            text: "پروفایل شما با موفقیت بروز رسانی شد",
            icon: "success",
            showConfirmButton: true,
            confirmButtonText: "تایید"
          });
          this.disabled1 = false;
        })
        .catch((err) => {
          this.disabled1 = false;
          this.$swal({
            title: "عملیات موفقیت آمیز نبود",
            text: "اطلاعات را به صورت کامل وارد نمایید",
            icon: "warning",
            showConfirmButton: true,
            confirmButtonText: "تایید"
          });
        });
    }
  },
     metaInfo() {
    return {
      title: "اطلاعات کاربری",
      meta: [
        {
          name: "description",
          content:
            "صفحه اطلاعات کاربری در سایت بانک کتاب میرداماد"
        },
        {
          property: "og:title",
          content:"اطلاعات کاربری"
        },
        { name: "robots", content: "index,follow" }
      ]
    };
  },
  mounted() {
    this.$axios.get("/user/profile").then((res) => {
      this.name =
        res.data.data.user.name != null ? res.data.data.user.name : "";
      this.email =
        res.data.data.user.email != null ? res.data.data.user.email : "";
    });
     document.getElementById("Content").scrollIntoView({behavior:'smooth'})

  },
  components: {
    BButton,
    BFormInput,
    BFormGroup
  },
  data() {
    return {
      disabled1: false,
      disabled2: false,
      name: null,
      email: null,
      oldPassword: null,
      password: null,
      rePassword: null
    };
  }
};
</script>
<style>
@media (max-width:768px){
  .colMD12{
        flex: 0 0 100%;
    max-width: 100%;
  }
}
.profileButton {
  color: #ffdd55;
  background-color: #333333;
  font-weight: bold;
    width: 30%;
  margin-right: 10px;
}
.col-6 {
  padding: 20px;
}
.col-6 h3 {
  margin-bottom: 30px;
  color: black;
}
.disbledLink {
  pointer-events: none;
  opacity: 0.7;
  cursor: not-allowed;
}
.swal2-container{
  z-index: 1111111000;
}
</style>
